import { inject } from '@angular/core';
import { AuthFactoryService } from '../authFactory.service';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';

export const OIDCSigninGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authFactoryService = inject(AuthFactoryService);

  authFactoryService.redirectToLogin();
  return of(true);
};
